import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { NgbActiveModal, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { passwordValidator } from 'src/app/core/helpers/validators';
import { ApiService } from 'src/app/core/providers/api/api.service';
import { AppContextService } from 'src/app/core/providers/context/AppContextService ';
import { ToastService } from 'src/app/core/providers/toast/toast.service';
import { CardFormComponent } from 'src/app/shared/card-form/card-form.component';
import { MessageBusService } from 'src/app/core/providers/busMessage/messageBusService';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
  selector: 'app-update-profile-modal',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgbModalModule,
    SharedModule,
    TranslateModule,
    CardFormComponent,
  ],
  templateUrl: './update-profile-modal.component.html',
  styleUrls: ['./update-profile-modal.component.scss'],
})
export class UpdateProfileModalComponent implements OnInit {
  profileForm: FormGroup;
  isSaving = false;
  submitted = false;
  context: any;
  mode: 'show' | 'edit' | 'create' = 'edit';
  user: any;

  constructor(
    private formBuilder: FormBuilder,
    private apiService: ApiService,
    private toastService: ToastService,
    public activeModal: NgbActiveModal,
    private appContextService: AppContextService,
    private messageBus: MessageBusService,
    public translate: TranslateService
  ) {
    this.profileForm = this.formBuilder.group({
      firstName: [{ value: '', disabled: true }],
      lastName: [{ value: '', disabled: true }],
      email: [{ value: '', disabled: true }],
      phone: ['', [Validators.required]],
      plainPassword: ['', [passwordValidator]],
      oldPassword: [''],
    });
  }

  ngOnInit(): void {
    this.appContextService.context$.subscribe((context) => {
      this.context = context;
      this.loadUserProfile();
    });

    this.profileForm
      .get('plainPassword')
      ?.valueChanges.subscribe((password) => {
        const oldPasswordControl = this.profileForm.get('oldPassword');
        if (password) {
          oldPasswordControl?.setValidators([Validators.required]);
        } else {
          oldPasswordControl?.clearValidators();
        }
        oldPasswordControl?.updateValueAndValidity();
      });
  }

  loadUserProfile(): void {
    const idUserFirm = this.context.user.userFirm;
    this.apiService.getById('user_firms', idUserFirm).subscribe((user) => {
      this.user = user;
      this.profileForm.patchValue(this.user);
    });
  }

  onCancelEdit() {
    this.profileForm.patchValue({
      ...this.user,
      ...{ plainPassword: '', oldPassword: '' },
    });
    return;
  }

  onSubmit(): void {
    this.submitted = true;
    if (this.profileForm.valid) {
      this.isSaving = true;
      const formData = this.profileForm.getRawValue();
      this.apiService.update('me', formData).subscribe({
        next: () => {
          this.toastService.show({
            message: this.translate.instant('updateProfileModal.saveSuccess'),
            classname: 'bg-success text-light',
            delay: 2500,
          });
          this.messageBus.setMessage({ type: 'CONTEXT_CHANGED' });
          this.activeModal.close();
        },
        error: () => {
          this.isSaving = false;
        },
      });
    }
  }
}
